var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrowR(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 38,
    viewBox: "0 0 74 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.3867 0.416809H53.9825L74.0009 18.771H61.4051L41.3867 0.416809Z",
    fill: "#7630FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74 18.771H61.4042L41.3858 37.1252H53.9817L74 18.771Z",
    fill: "#7630FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8438 0.416809H33.4396L53.4579 18.771H40.8621L20.8438 0.416809Z",
    fill: "#7630FF",
    fillOpacity: 0.59
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.457 18.771H40.8612L20.8429 37.1252H33.4387L53.457 18.771Z",
    fill: "#7630FF",
    fillOpacity: 0.59
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.416809H12.5958L32.6142 18.771H20.0183L0 0.416809Z",
    fill: "#7630FF",
    fillOpacity: 0.33
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6133 18.771H20.0175L-0.000869751 37.1252H12.5949L32.6133 18.771Z",
    fill: "#7630FF",
    fillOpacity: 0.33
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrowR);
export default __webpack_public_path__ + "static/media/errow_r.ec5dc9717573d8067e29dc82d00cfdf9.svg";
export { ForwardRef as ReactComponent };